module.exports = __webpack_public_path__ + "static/media/m0rall.569ed964.svg";